import { render } from "./trading-accounts-change-password.vue?vue&type=template&id=622ef8cf"
import script from "./trading-accounts-change-password.vue?vue&type=script&lang=js"
export * from "./trading-accounts-change-password.vue?vue&type=script&lang=js"

import "./trading-accounts-change-password.vue?vue&type=style&index=0&id=622ef8cf&lang=css"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__